module.exports = __webpack_public_path__ + "img/ARTICLE_HEADING.7ddebf5e.svg";